import React from 'react';
import { shape, string, number } from 'prop-types';

import { ProgressIndicatorLinear } from '@andes/progress-indicator-linear';

/**
 * propTypes ProgressBarDefault
 * @param {Object} props - Component properties
 * @param {string} props.namespace - CSS namespace for classes
 * @param {Object} props.progress_bar - Progress bar configuration
 * @param {string} props.progress_bar.color_hex - Bar color in hexadecimal format
 * @param {number} props.progress_bar.percent - Progress percentage (0-100)
 * @returns {JSX.Element} Progress bar component
 */

const ProgressBarDefault = ({ namespace, progress_bar }) => {
  const { color_hex, percent } = progress_bar;

  return (
    <div className={`${namespace}__progressbar-container`}>
      <ProgressIndicatorLinear color={color_hex} highlight value={Math.min(Math.max(percent, 0), 100)} />
    </div>
  );
};

ProgressBarDefault.propTypes = {
  namespace: string.isRequired,
  progress_bar: shape({
    color_hex: string,
    percent: number,
  }),
};

export default ProgressBarDefault;
